import React from 'react';
import { Button, ButtonProps } from '@mui/material';

export const CancelButton: React.FC<ButtonProps> = (props) => {
  return (
    <Button variant="outlined" {...props}>
      Cancel
    </Button>
  );
};

export default CancelButton;
